import "./PricingInfo.module.css";
import Header from "@/reusable_sections/Header";
import CalculationPlanning from "./sections/CalculationPlanning";
import IndividuellerPreis from "./sections/IndividuellerPreis";
import Footer from "@/reusable_sections/Footer";
export default function PricingInfoPage() {
  return <div>
      <Header />
      <CalculationPlanning />
      <IndividuellerPreis />
      <Footer />
    </div>;
}